import React from 'react';
import { CtaButton } from '../components/CtaButton';
export function Footer() {
  return <footer className="w-full bg-white pb-28 pt-12 sm:pb-32" data-id="element-187" data-mp="241jihmxdbdyy">
      <div className="mx-auto w-full max-w-3xl px-4 text-center sm:px-6" data-id="element-188" data-mp="23yx8lgn08mdk">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-189" data-mp="1q0qkgs7uy0r3">
          Don’t miss your access
        </p>
        <h2 className="mt-3 font-display text-[22px] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-[28px]" data-id="element-190" data-mp="1v263keqh5x6u">
          Your complete clinical planning library is one click away.
        </h2>

        <div className="mx-auto mt-6 max-w-md" data-id="element-191" data-mp="17b0rmannnp1t">
          <CtaButton label="Get the Master System for $27" sub="Instant digital access • One-time payment • Lifetime access • 7-day guarantee" size="md" data-id="element-192" data-mp="17cbv09d6uuse" />
        </div>

        <p className="mt-10 text-[12px] leading-relaxed text-ink-500" data-id="element-193" data-mp="xdctrbur61ff">
          The Aligner Planning Master System™ © 2026 All Rights Reserved.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[11.5px] leading-relaxed text-ink-500" data-id="element-194" data-mp="2re3gv9grwago">
          This is an educational resource. Treatment decisions should always be based on your
          professional judgment, patient-specific findings, applicable standards of care, and
          appropriate clinical training.
        </p>
      </div>
    </footer>;
}